/* src/app/components/modal-update-app/modal-update-app.component.scss */
:host .update-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  min-height: 400px;
  height: 100%;
  text-align: center;
  overflow: auto;
}
:host .logo-app {
  width: 100px;
  height: 100px;
  margin: 20px auto;
  border-radius: 20px;
}
:host .logo-app > * {
  width: 100%;
  height: 100%;
  object-fit: cover;
  color: var(--ion-color-primary);
  stroke: var(--ion-color-primary);
}
:host .info-message-title {
  font-weight: bold;
  margin-bottom: 10px;
}
:host .btn {
  margin-top: auto;
  margin-bottom: 40px;
  height: auto;
}
/*# sourceMappingURL=modal-update-app.component.css.map */
